var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarWedding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2.25C7.41421 2.25 7.75 2.58579 7.75 3V4H16.25V3C16.25 2.58579 16.5858 2.25 17 2.25C17.4142 2.25 17.75 2.58579 17.75 3V4H20C21.1046 4 22 4.89543 22 6V7.25H2V6C2 4.89543 2.89543 4 4 4H6.25V3C6.25 2.58579 6.58579 2.25 7 2.25Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 8.75H2V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V8.75ZM10.7847 17.3695C9.60777 16.4409 8 14.9071 8 13.4568C8 11.034 10.2001 10.1295 12 12.001C13.7999 10.1295 16 11.034 16 13.4568C16 14.9071 14.3922 16.441 13.2153 17.3695C12.6825 17.7898 12.4161 18 12 18C11.5839 18 11.3175 17.7898 10.7847 17.3695Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarWedding);
export default __webpack_public_path__ + "static/media/calendar-wedding.139dcf5d8e58de1485b186cec310afea.svg";
export { ForwardRef as ReactComponent };